module.exports = __webpack_public_path__ + "img/notification.f7a93016.svg";